var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechcombankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjlJREFUeNrsmLFLw0AUxpNUOnQUdRIbQTsp+AcIFl1bHLuogw6dnMXB1bo5i1gQitDFQTsJdurkIkWnOrQVN0GcKg4Sv5QINeYudy+XingfPF5p+3rfu/drcq1haGlpaWlp/Xe1bduk1c2MRF3bimq8k84cmE6yiTwqU4v375qOdYs88WsNwHgJaQcxj7iGmXFB89tI+4g5mTqlDWDRPc/8lxYQV2GT8MwfDjzlNlGnNmFSsBnY+SDdIbJ2t/UShI2380G6RywF1SmdQIh5g4XTADYskXCyImLD0jecArARqlOGkAA2BgenM0SJUJcVwclShA1LTcQNoidZJ3xVsxRi41fFdIwidrGOx3lCE0I4mTFg46oM41u+jVhGukSkVOJkxYBNxW/eVYRJcHGy4sCG9WIcOJlxYsP5XinDyYoTG4FJvBFxGmMh1CIejey2PZuQrJlEJAlrPQHTHvMqhO7WkI4I420gVkVuPlhjA+mUYL6Gz89zv8R4QwWpSPjwRcS5wGnUNV+mmMfOF4TvA1hoE+mEsFDDMZ3sdOfhg2M+QTGffmz1pM5CKnFSiY3wUUIVTqqxkT6NRsHJM36sEhvp0ygm4ZpYJ9xBXxHPiHcKNmHmpX7QEHDq7yDqanhckGg+FJtIv4kFcfoxftTlvONDZGwiNSBwdWJeNbwmqoy6OupWhvK3Cgcn7vg5ONVRlx/K3yocnITH78Opb14GG6VycUJUCXU5xEV3KpMytLS0tLS0tP6oPgUYAFrEItWaNbagAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechcombankIcon);
export default __webpack_public_path__ + "static/media/techcombank_icon.c1673b6b2406514d2e4674f6f00ee7d4.svg";
export { ForwardRef as ReactComponent };